import { Directive ,ElementRef, HostListener } from '@angular/core';
import {AbstractControl, FormGroup ,ValidatorFn, Validator, NG_VALIDATORS, Validators, FormControl} from "@angular/forms";


@Directive({
  selector: '[appPinCode]  [ngModel]',
  providers:[{provide: NG_VALIDATORS, useExisting: PinCodeDirective , multi: true}]
})
export class PinCodeDirective {
  validator: ValidatorFn;
  private regExp: RegExp = new RegExp(/^[1-9 ][0-9 ]{1,6}$/g); 
 

  constructor() { 
    this.validator = this.appPinCode();
  }
  validate(control: FormControl){
    return this.validator(control)
  }

  appPinCode(){
    return ( control :FormControl) => {
      let isValid =this.regExp.test(control.value);
      if(isValid){
        return null;
      }else{
        return{
          appPinCode:{
            valid:false
          }
        };
      }
    };
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2927200756/src/src/app/shared/directive/pin-code.directive.ts